<script>
	import { PUBLIC_PATH } from '$env/static/public';
	export let contactData;
</script>

<section
	id="contact_us"
	aria-label="Contact Us"
	class="relative bg-background-alt overflow-hidden px-space_40 py-8 lg:px-0 lg:py-12"
	style="background: radial-gradient(70.21% 70.21% at 47.33% -51%, #D1D8F6 0%, #FFFFFF 100%)"
>
	<!-- Background grid -->
	<div
		class="pointer-events-none absolute inset-0 opacity-[0.08] invert bg-repeat"
		style="background-image: url('{PUBLIC_PATH}/images/grid-line.svg');"
	></div>

	<div class="relative mx-auto flex max-w-8xl flex-col items-center gap-padding_xxlg lg:px-3">
		<h2
			class="text-center text-[1.1875rem] font-semibold leading-[1.5rem] text-backdrop lg:font-barlow lg:text-[2.5rem] lg:leading-[3.5rem]"
		>
			{contactData.title}
		</h2>

		<div
			class="flex w-full flex-col gap-padding_xsm lg:mx-auto lg:max-w-[50rem] lg:flex-row lg:gap-padding_xxlg"
		>
			{#each contactData.methods as method}
				<div
					class="flex h-16 flex-1 items-center gap-padding_lg rounded-shape-corner_lg border border-border py-padding_default px-padding_xlg"
				>
					<div
						class="flex h-space_40 w-space_40 shrink-0 items-center justify-center rounded-shape-corner_full bg-grey text-grey-body"
					>
						<img src="{PUBLIC_PATH}/{method.icon}" alt={method.id} class="h-5 w-5" />
					</div>
					<p
						class="whitespace-nowrap text-[0.9375rem] font-medium leading-[1.5rem] tracking-[0.01875rem] text-title"
					>
						{method.text}
					</p>
				</div>
			{/each}
		</div>
	</div>
</section>
